import './AboutUs.css';

const AboutUs = () => {
  return (
    <main className="au-main">

      {/* About Us Hero */}
      <section aria-labelledby="au-heading" className="au-hero-section">
        <div className="au-hero-text">
          <h1 id="au-heading" className="au-title">About us</h1>
          <p className="au-desc">
            We are a food health-tech company with objective to add more time to
            your day and more years to your life by curating clean, choiceful,
            cost-effective and convenient food options.
          </p>
        </div>
        <img
          className="au-hero-img"
          src="/img/about-us.svg"
          alt="Assorted healthy meals and dishes"
        />
      </section>

      {/* Our Brands */}
      <section aria-labelledby="au-brands-heading" className="au-brands-section">
        <h2 id="au-brands-heading" className="au-brands-heading">Our Brands</h2>
        <div className="au-brands-list">

          <a href="https://localheros.in/" target="_blank" rel="noopener noreferrer" aria-label="Visit Local Heros">
            <article className="au-brand-card">
              <div className="au-brand-inner">
                <img src="/img/LH-logo.svg" alt="Local Heros logo" className="au-brand-logo" />
                <div className="au-brand-info">
                  <h3 className="au-brand-name">Local Heros</h3>
                  <p className="au-brand-tagline">The Meal Company - Premium Ingredients and taste, Lite on tummy and lite on wallet</p>
                </div>
              </div>
              <div className="au-brand-arrow" aria-hidden="true">
                <img src="/img/arrow.svg" alt="" className="au-arrow-icon" />
              </div>
            </article>
          </a>

          <a href="https://chickenow.in/" target="_blank" rel="noopener noreferrer" aria-label="Visit Chickenow">
            <article className="au-brand-card">
              <div className="au-brand-inner">
                <img src="/img/CN-logo.svg" alt="Chickenow logo" className="au-brand-logo" />
                <div className="au-brand-info">
                  <h3 className="au-brand-name">Chickenow</h3>
                  <p className="au-brand-tagline">The Meat Company - Making Protein, Your Routine</p>
                </div>
              </div>
              <div className="au-brand-arrow" aria-hidden="true">
                <img src="/img/arrow.svg" alt="" className="au-arrow-icon" />
              </div>
            </article>
          </a>

          <a href="https://thenewluxury.in/" target="_blank" rel="noopener noreferrer" aria-label="Visit The New Luxury">
            <article className="au-brand-card">
              <div className="au-brand-inner">
                <div className="au-tnl-logo-wrap">
                  <img src="/img/TNL-logo.svg" alt="The New Luxury logo" className="au-tnl-logo" />
                </div>
                <div className="au-brand-info">
                  <h3 className="au-brand-name">The New Luxury</h3>
                  <p className="au-brand-tagline">The Premium Food &amp; Health Concierge Company - Curating Wellness, One Plate at a Time</p>
                </div>
              </div>
              <div className="au-brand-arrow" aria-hidden="true">
                <img src="/img/arrow.svg" alt="" className="au-arrow-icon" />
              </div>
            </article>
          </a>

          <a href="https://scienceofliving.fit/" target="_blank" rel="noopener noreferrer" aria-label="Visit Science Of Living">
            <article className="au-brand-card">
              <div className="au-brand-inner">
                <img src="/img/SOL-logo.svg" alt="Science Of Living logo" className="au-brand-logo" />
                <div className="au-brand-info">
                  <h3 className="au-brand-name">Science Of Living</h3>
                  <p className="au-brand-tagline">The Prognostic Bloodwork Company - Precision Insights for a Better Health</p>
                </div>
              </div>
              <div className="au-brand-arrow" aria-hidden="true">
                <img src="/img/arrow.svg" alt="" className="au-arrow-icon" />
              </div>
            </article>
          </a>

        </div>
      </section>

      {/* Catalogue banner */}
      <section aria-label="Catalogue" className="au-catalogue-section">
        <p className="au-catalogue-text">
          Explore our full range of fresh meats, signature meals, and health-focused essentials in one place. Browse our catalogue
        </p>
        <a
          href="/Manual.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="au-catalogue-btn"
          aria-label="Open catalogue PDF in a new tab"
        >
          Catalogue
        </a>
      </section>

      {/* Placeholder */}
      <section className="au-placeholder" aria-label="Additional content area" />

    </main>
  );
};

export default AboutUs;
